// A blob offered to the browser as a file to keep. Shared rather than written twice: /qr-code saves a code and
// /image saves a picture, and neither of them owns the four lines that put a name on a download.
export function download(name: string, blob: Blob) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = name;
  link.click();
  // On the next task rather than now: the click starts a read of the blob that revoking underneath would cut off.
  setTimeout(() => URL.revokeObjectURL(url));
}
